import { createHttpInstance } from '~/common/utils/http';

const httpInstance = createHttpInstance('backoffice');

export default httpInstance;
